module.exports = __webpack_public_path__ + "static/mr-press-10-cb626490b120108b0f17ca323475aa95.jpg";